module.exports = __webpack_public_path__ + "img/logo-safezone.5f4e086d.png";